// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { ValidationErrorReasons, B2BStatsReportSaveResponse } from "../schema";

export function serialize_B2BStatsReportSaveResponse(obj: B2BStatsReportSaveResponse): string {
  const serialized = ((value: { kind: "VALIDATION_ERROR"; validationErrorReasons: ValidationErrorReasons } | { kind: "SUCCESS"; reportId: number }): unknown => {
    switch (value.kind) {
      case "VALIDATION_ERROR": {
        return {
          kind: "VALIDATION_ERROR",
          validationErrorReasons: ((value: { fields: { additionalProperties: Record<string, string[]> }; general: string[] }): unknown => {
            return {
              fields: ((value: { additionalProperties: Record<string, string[]> }): unknown => {
                const unordered_obj: Record<string, unknown> = {
                  ...Object.fromEntries(
                    Object.entries(value.additionalProperties).map(([propertyKey, propertyValue]) => {
                      return [
                        propertyKey,
                        ((value: string[]): unknown => {
                          return value.map((value: string): unknown => {
                            return value;
                          });
                        })(propertyValue),
                      ];
                    }),
                  ),
                };
                return Object.keys(unordered_obj)
                  .sort()
                  .reduce(
                    (obj, key) => {
                      obj[key] = unordered_obj[key];
                      return obj;
                    },
                    {} as Record<string, unknown>,
                  );
              })(value["fields"]),
              general: ((value: string[]): unknown => {
                return value.map((value: string): unknown => {
                  return value;
                });
              })(value["general"]),
            };
          })(value["validationErrorReasons"]),
        };
      }
      case "SUCCESS": {
        return {
          kind: "SUCCESS",
          reportId: ((value: number): unknown => {
            return value;
          })(value["reportId"]),
        };
      }
    }
  })(obj);
  return renderJsonWithNumbersAsBigint(serialized);
}
export function deserialize_B2BStatsReportSaveResponse(str: string): ParserResult<B2BStatsReportSaveResponse> {
  return ((value: unknown): ParserResult<{ kind: "VALIDATION_ERROR"; validationErrorReasons: ValidationErrorReasons } | { kind: "SUCCESS"; reportId: number }> => {
    return ((value: unknown): ParserResult<{ kind: "VALIDATION_ERROR"; validationErrorReasons: ValidationErrorReasons } | { kind: "SUCCESS"; reportId: number }> => {
      if (value == null) {
        return { success: false, reason: `[#/components/schemas/B2BStatsReportSaveResponse]: '${value}' expected to be non-null.` };
      }
      if (typeof value != "object") {
        return { success: false, reason: `[#/components/schemas/B2BStatsReportSaveResponse]: ${value} expected to be of type 'object'.` };
      }
      if (!hasProp(value, "kind")) {
        return { success: false, reason: `[#/components/schemas/B2BStatsReportSaveResponse]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'kind'.` };
      }
      if (typeof value["kind"] != "string") {
        return { success: false, reason: `[#/components/schemas/B2BStatsReportSaveResponse]: '${value["kind"]}' expected to be of type 'string'.` };
      }
      const discriminator = value["kind"];
      switch (discriminator) {
        case "VALIDATION_ERROR": {
          const parsedVariant = ((
            value: unknown,
          ): ParserResult<{
            validationErrorReasons: ValidationErrorReasons;
          }> => {
            if (typeof value !== "object") {
              return { success: false, reason: `[#/components/schemas/B2BStatsReportSaveResponse/VALIDATION_ERROR]: '${value}' expected to be of type 'object'.` };
            }
            if (value === null) {
              return { success: false, reason: `[#/components/schemas/B2BStatsReportSaveResponse/VALIDATION_ERROR]: '${value}' expected to not be null.` };
            }
            if (!hasProp(value, "validationErrorReasons")) {
              return { success: false, reason: `[#/components/schemas/B2BStatsReportSaveResponse/VALIDATION_ERROR/validationErrorReasons]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'validationErrorReasons'.` };
            }
            const parsed_validationErrorReasons = ((): ParserResult<ValidationErrorReasons> => {
              return ((value: unknown): ParserResult<ValidationErrorReasons> => {
                return ((
                  value: unknown,
                ): ParserResult<{
                  fields: { additionalProperties: Record<string, string[]> };
                  general: string[];
                }> => {
                  if (typeof value !== "object") {
                    return { success: false, reason: `[#/components/schemas/ValidationErrorReasons]: '${value}' expected to be of type 'object'.` };
                  }
                  if (value === null) {
                    return { success: false, reason: `[#/components/schemas/ValidationErrorReasons]: '${value}' expected to not be null.` };
                  }
                  if (!hasProp(value, "fields")) {
                    return { success: false, reason: `[#/components/schemas/ValidationErrorReasons/fields]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'fields'.` };
                  }
                  const parsed_fields = ((): ParserResult<{ additionalProperties: Record<string, string[]> }> => {
                    return ((value: unknown): ParserResult<{ additionalProperties: Record<string, string[]> }> => {
                      if (typeof value !== "object") {
                        return { success: false, reason: `[#/components/schemas/ValidationErrorReasons/fields]: '${value}' expected to be of type 'object'.` };
                      }
                      if (value === null) {
                        return { success: false, reason: `[#/components/schemas/ValidationErrorReasons/fields]: '${value}' expected to not be null.` };
                      }
                      const parsed_additionalProperties = ((): ParserResult<Record<string, string[]>> => {
                        const parsed = Object.entries(value).map(([key, value]): [string, ParserResult<string[]>] => {
                          return [
                            key,
                            ((value: unknown): ParserResult<string[]> => {
                              if (!isArray(value)) {
                                return { success: false, reason: `[#/components/schemas/ValidationErrorReasons/fields/[array]]: '${value}' expected to be an array.` };
                              }
                              const parsed = value.map((value: unknown): ParserResult<string> => {
                                if (typeof value !== "string") {
                                  return { success: false, reason: `[#/components/schemas/ValidationErrorReasons/fields/additionalProperty]: '${value}' expected to be of type string.` };
                                }
                                return { success: true, value: value };
                              });
                              if (parsed.find((value) => !value.success) !== undefined) {
                                return {
                                  success: false,
                                  reason: `[#/components/schemas/ValidationErrorReasons/fields/[array]]: Reason(s): '${parsed
                                    .filter((p) => !p.success)
                                    .map((p) => p.reason)
                                    .join(", ")}'.`,
                                };
                              }
                              return {
                                success: true,
                                value: parsed.map((entry) => {
                                  assert(entry.success == true);
                                  return entry.value;
                                }),
                              };
                            })(value),
                          ];
                        });
                        if (parsed.find(([_, value]) => !value.success) !== undefined) {
                          return {
                            success: false,
                            reason: `[#/components/schemas/ValidationErrorReasons/fields]: Reason(s): '${parsed
                              .map(([_, value]) => value)
                              .filter((p) => !p.success)
                              .map((p) => p.reason)
                              .join(", ")}'.`,
                          };
                        }
                        return {
                          success: true,
                          value: Object.fromEntries(
                            parsed.map(([key, value]) => {
                              assert(value.success);
                              return [key, value.value];
                            }),
                          ),
                        };
                      })();
                      if (!parsed_additionalProperties.success) {
                        return { success: false, reason: parsed_additionalProperties.reason };
                      }
                      return { success: true, value: { additionalProperties: parsed_additionalProperties.value } };
                    })(value["fields"]);
                  })();
                  if (!parsed_fields.success) {
                    return { success: false, reason: parsed_fields.reason };
                  }
                  if (!hasProp(value, "general")) {
                    return { success: false, reason: `[#/components/schemas/ValidationErrorReasons/general]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'general'.` };
                  }
                  const parsed_general = ((): ParserResult<string[]> => {
                    return ((value: unknown): ParserResult<string[]> => {
                      if (!isArray(value)) {
                        return { success: false, reason: `[#/components/schemas/ValidationErrorReasons/general]: '${value}' expected to be an array.` };
                      }
                      const parsed = value.map((value: unknown): ParserResult<string> => {
                        if (typeof value !== "string") {
                          return { success: false, reason: `[#/components/schemas/ValidationErrorReasons/general]: '${value}' expected to be of type string.` };
                        }
                        return { success: true, value: value };
                      });
                      if (parsed.find((value) => !value.success) !== undefined) {
                        return {
                          success: false,
                          reason: `[#/components/schemas/ValidationErrorReasons/general]: Reason(s): '${parsed
                            .filter((p) => !p.success)
                            .map((p) => p.reason)
                            .join(", ")}'.`,
                        };
                      }
                      return {
                        success: true,
                        value: parsed.map((entry) => {
                          assert(entry.success == true);
                          return entry.value;
                        }),
                      };
                    })(value["general"]);
                  })();
                  if (!parsed_general.success) {
                    return { success: false, reason: parsed_general.reason };
                  }
                  return { success: true, value: { fields: parsed_fields.value, general: parsed_general.value } };
                })(value);
              })(value["validationErrorReasons"]);
            })();
            if (!parsed_validationErrorReasons.success) {
              return { success: false, reason: parsed_validationErrorReasons.reason };
            }
            return { success: true, value: { validationErrorReasons: parsed_validationErrorReasons.value } };
          })(value);
          if (!parsedVariant.success) {
            return { success: false, reason: parsedVariant.reason };
          }
          return { success: true, value: { kind: "VALIDATION_ERROR" as const, ...parsedVariant.value } };
        }
        case "SUCCESS": {
          const parsedVariant = ((
            value: unknown,
          ): ParserResult<{
            reportId: number;
          }> => {
            if (typeof value !== "object") {
              return { success: false, reason: `[#/components/schemas/B2BStatsReportSaveResponse/SUCCESS]: '${value}' expected to be of type 'object'.` };
            }
            if (value === null) {
              return { success: false, reason: `[#/components/schemas/B2BStatsReportSaveResponse/SUCCESS]: '${value}' expected to not be null.` };
            }
            if (!hasProp(value, "reportId")) {
              return { success: false, reason: `[#/components/schemas/B2BStatsReportSaveResponse/SUCCESS/reportId]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'reportId'.` };
            }
            const parsed_reportId = ((): ParserResult<number> => {
              return ((value: unknown): ParserResult<number> => {
                if (typeof value === "number") {
                  return { success: true, value: value };
                }
                return { success: false, reason: `[#/components/schemas/B2BStatsReportSaveResponse/SUCCESS/reportId]: '${value}' expected to be of type number.` };
              })(value["reportId"]);
            })();
            if (!parsed_reportId.success) {
              return { success: false, reason: parsed_reportId.reason };
            }
            return { success: true, value: { reportId: parsed_reportId.value } };
          })(value);
          if (!parsedVariant.success) {
            return { success: false, reason: parsedVariant.reason };
          }
          return { success: true, value: { kind: "SUCCESS" as const, ...parsedVariant.value } };
        }
        default:
          return { success: false, reason: `[#/components/schemas/B2BStatsReportSaveResponse]: '${discriminator}' expected to be one of 'VALIDATION_ERROR, SUCCESS'.` };
      }
    })(value);
  })(parseJsonWithNumbersAsBigint(str));
}
